import { withScriptjs, withGoogleMap } from "react-google-maps"
import { googleMapsApiKey } from 'client.config'
import mapStyleOptions from './mapStyleOptions.json'

// See: https://tomchentw.github.io/react-google-maps
// https://developers.google.com/maps/documentation/javascript/tutorial

export const defaultCenter = { lat: 41.7710984, lng: -88.1475656 }
export const defaultZoom = 13

export const mapStyles = {

  mapContainer: {

    // Flex not working on Safari
    //display: 'flex', flexDirection: 'column',

    // height: '100%',
  },
  mapElement: {

    // Flex not working on Safari
    //height: '100%', flex: '1 0 auto',

    // height: '100vh', marginTop: '-56px', // Hack for header

    // overflow: 'visible',
    // minHeight: '520px' // 260
  },

  searchBoxInput: {
    boxSizing: `border-box`,
    border: `1px solid transparent`,
    width: `100%`, // '240px'
    maxWidth: '640px',
    height: `32px`,
    margin: `0 auto`,
    padding: `0 12px`,
    borderRadius: `20px`,
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
    fontSize: `14px`,
    outline: `none`,
    textOverflow: `ellipses`,
  }
}

// https://developers.google.com/maps/documentation/javascript/controls#Adding_Controls_to_the_Map
export const mapOptions = {
  fullscreenControl: false,
  mapTypeControl: false,
  //streetView: false,
  streetViewControl: false,
  zoomControl: false,
  // keyboardShortcuts: false,
  //zoomControlOptions: { position: google.maps.ControlPosition.TOP_RIGHT },
  styles: mapStyleOptions
}

export const markerIconOptions = {
  path: 'm 14.473641,11.125485 c 0,3.106602 -2.518398,5.625 -5.6249996,5.625 -3.1066017,0 -5.625,-2.518398 -5.625,-5.625 0,-3.1066013 2.5183983,-5.6249996 5.625,-5.6249996 3.1066016,0 5.6249996,2.5183983 5.6249996,5.6249996 z', //google.maps.SymbolPath.CIRCLE,
  scale: 1,
  fillColor: '#FF6464',
  fillOpacity: 1,
  strokeColor: '#FF6464',
  strokeWeight: 8
}

export const styledMarkerPlaceholderUrl = 'https://www.google.com/mapfiles/transparent.png?styled-marker'

export const createMapWithDefaults = Map => {

  const MapWithScript = withScriptjs(withGoogleMap(Map))

  return props =>
    <MapWithScript {...{
      googleMapURL: `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${googleMapsApiKey}&libraries=geometry,drawing,places`,
      loadingElement:
        <div className="google-map-loading" style={ mapStyles.mapContainer } />,
      containerElement:
        <div className="google-map-container" style={ mapStyles.mapContainer } />,
      mapElement:
        <div className="google-map-element" style={ mapStyles.mapElement } />,
      ...props
    }}
    />
}
